import { isServer } from '@/services/Utilities/Runtime';
import type { ILogger } from './loggerBase';
import loggerClient from './loggerClient';
import loggerServer from './loggerServer';

// todo - once BrowserClient is moved over to BrowserHttpClient nothing on the client should be calling `logger.`
//  so this can be removed
export const logger = (isServer ? loggerServer : loggerClient) as ILogger;
